import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';

import { ApiUrlService } from '@core/services/api-url.service';
import { HelperService } from '@core/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(
    private httpClient: HttpClient,
    private helperService: HelperService,
    private apiUrlService: ApiUrlService
  ) {}

  getPDF(fileName: string) {
    const body = {
      fileName
    };
    return this.httpClient.post(this.apiUrlService.getPdfUrl, body).pipe(
      map((data: any) => {
        if (this.helperService.checkAPIResponse(data)) {
          data = this.helperService.getAPIDataResponse(data)[0];
          return data;
        }
      }),
      catchError(error => {
        return error;
      })
    );
  }

  public getCurrentToken() {
    return sessionStorage.getItem('auth');
  }

  public currentUser() {
    return sessionStorage.getItem('user') !== null && sessionStorage.getItem('form_fields') !== ''
      ? this.helperService.getObjUser()
      : false;
  }
}
